import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { LegalMarkdown } from '@/components/chat/LegalMarkdown';
import { Loader2, ScrollText } from 'lucide-react';

interface LegalCompareModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: string;
  isLoading: boolean;
}

export const LegalCompareModal: React.FC<LegalCompareModalProps> = ({
  isOpen,
  onClose,
  title,
  content,
  isLoading,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-4xl max-h-[85vh] flex flex-col p-6 overflow-hidden bg-background/95 backdrop-blur-md border border-border/55">
        <DialogHeader className="border-b pb-4 flex flex-row items-center gap-2 shrink-0">
          <ScrollText className="h-5 w-5 text-primary" />
          <DialogTitle className="text-xl font-bold tracking-tight">
            {title}
          </DialogTitle>
        </DialogHeader>

        <div className="flex-1 overflow-y-auto py-4 min-h-[250px]">
          {isLoading ? (
            <div className="flex flex-col items-center justify-center py-12 gap-3 text-muted-foreground">
              <Loader2 className="h-8 w-8 animate-spin text-primary" />
              <p className="text-sm font-medium animate-pulse">
                Procesando resoluciones con inteligencia jurídica de Gemini...
              </p>
            </div>
          ) : (
            <div className="prose prose-sm dark:prose-invert max-w-none prose-headings:font-bold prose-headings:tracking-tight prose-a:text-primary leading-relaxed">
              <LegalMarkdown content={content} />
            </div>
          )}
        </div>

        <div className="border-t pt-4 flex justify-end shrink-0 gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
          >
            Cerrar
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
